import React, { Component } from "react";
import { getProperty } from "../../../CommonFunctions";

// Correct imports from react-icons
import { FiUsers, FiMail, FiMessageSquare } from 'react-icons/fi';
import { MdMessage, MdChat, MdSms } from 'react-icons/md';
import { FaWhatsapp } from 'react-icons/fa';
import { SiWhatsapp } from 'react-icons/si';

export default class CampaignStats extends Component {
  render() {
    const { run, campaign } = this.props;
    // campaign = { EnableEmail, EnableSMS, EnableWhatsapp }

    const stats = [
      {
        enabled: true,
        label: "Customers",
        value: getProperty(run, 'TotalCustomers') || 0,
        icon: <FiUsers size={18} color="#9333ea" />,
        borderColor: "#e9d5ff",
      },
      {
        enabled: campaign && campaign.hasOwnProperty('EnableWhatsapp') ? campaign.EnableWhatsapp : false,
        label: "WhatsApp",
        value: getProperty(run, 'WhatsappCount') || 0,
        icon: <FaWhatsapp size={18} color="#059669" />,
        borderColor: "#a7f3d0",
      },
      {
        enabled: campaign && campaign.hasOwnProperty('EnableSMS') ? campaign.EnableSMS : false,
        label: "SMS",
        value: getProperty(run, 'SMSCount') || 0,
        icon: <MdSms size={18} color="#2563eb" />,  // Changed from MdMessageCircle to MdSms
        borderColor: "#bfdbfe",
      },
      {
        enabled: campaign && campaign.hasOwnProperty('EnableEmail') ? campaign.EnableEmail : false,
        label: "Email",
        value: getProperty(run, 'EmailCount') || 0,
        icon: <FiMail size={18} color="#ea580c" />,
        borderColor: "#fed7aa",
      },
    ];

    return (
      <div style={{ display: "flex", gap: "16px" }}>
        {stats
          .filter((s) => s.enabled)
          .map((s, idx) => (
            <div
              key={idx}
              style={{
                backgroundColor: "white",
                minWidth: "240px",
                border: `1px solid ${s.borderColor}`,
                borderRadius: "12px",
                padding: "8px 16px",
                boxShadow: "0 1px 2px 0 rgba(0, 0, 0, 0.05)",
              }}
            >
              <div style={{ display: "flex", alignItems: "center", gap: "4px" }}>
                {s.icon}
                <p
                  style={{
                    fontSize: "14px",
                    color: "#4b5563",
                    fontWeight: 500,
                    margin: 0,
                  }}
                >
                  {s.label}
                </p>
              </div>
              <p
                style={{
                  fontSize: "20px",
                  fontWeight: 600,
                  color: "#374151",
                  margin: 0,
                }}
              >
                {s.value}
              </p>
            </div>
          ))}
      </div>
    );
  }
}